import React from "react";
import { Props } from "./types";

function HighlightIcon({ className, color = "currentColor" }: Props) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      width="16"
      height="16"
    >
      <path
        d="M17.5 3.5 L20.5 6.5 L9 18 L4 20 L6 15 L17.5 3.5Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="15"
        y1="6"
        x2="18"
        y2="9"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <line
        x1="3"
        y1="22.5"
        x2="21"
        y2="22.5"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}

export { HighlightIcon };
